import search from './reducer';

export default search;
